import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ERROR_MESSAGES = {
  auth_denied: 'You denied access. Please try again.',
  auth_failed: 'Authentication failed. Please try again.',
  invalid_callback: 'Invalid authentication callback.',
  no_email: 'Could not get your email from Google.',
  not_registered: 'Your email is not registered. Contact your administrator.',
  account_inactive: 'Your account has been deactivated. Contact admin.',
};

export default function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const error = searchParams.get('error');
    if (error) {
      toast.error(ERROR_MESSAGES[error] || 'Authentication failed');
      navigate('/login', { replace: true });
      return;
    }

    const completeAuth = async () => {
      try {
        const response = await axios.get(`${API}/auth/me`, { withCredentials: true });
        const userData = response.data;
        setUser(userData);
        toast.success('Login successful!');
        const slug = userData?.role_slug || userData?.role;
        const defaultPath = slug === 'box_agent' ? '/voting-boxes' : '/dashboard';
        navigate(defaultPath, { replace: true });
      } catch (err) {
        console.error('Auth error:', err);
        toast.error('Could not verify session. Please try logging in again.');
        navigate('/login', { replace: true });
      }
    };

    completeAuth();
  }, [navigate, searchParams, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Completing authentication...</p>
      </div>
    </div>
  );
}
